import SearchableSelectController from "../searchable_select_controller"

// The approver picker is the app's searchable select in multiple mode: same
// field, list and search look (`.ss-lucanto`), the list stays open between
// picks, and the chosen approvers show as chips in the field. It highlights the
// matched part of a name while searching, as it did before it took that look.
export default class extends SearchableSelectController {
  static values = {
    closeOnSelect: { type: Boolean, default: false },
    searchHighlight: { type: Boolean, default: true },
    placeholder: { type: String, default: "Select approvers..." }
  }
}
